module.exports = __webpack_public_path__ + "static/media/phonecoverpage3.bfd600cc.png";